<div class="outer-container">
  <ng-container *ngIf="chat$ | async as chatHistory">
    <mat-divider></mat-divider>

    <div [ngClass]="classes" class="inner-container">
      <div class="chat-container scrollbar" #chatContainer>
        <div *ngIf="isLoading$ | async" class="spinner">
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>

        <app-chat-message
          *ngFor="let chatMessage of chatHistory"
          [chatMessage]="chatMessage"
          (scrollPositionY)="onScrollPositionChange($event)"
          [isLoading]="(chatbotService.requestInProgress$ | async)!">
        </app-chat-message>
        <img
          *ngIf="chatbotService.requestInProgress$ | async"
          class="loading-dots"
          src="assets/images/dots.gif"
          alt="waiting ..." />
      </div>

      <app-chatbot-example-chips
        *ngIf="
          chatHistory.length === 1 && !this.selectedFileNames?.length
        "></app-chatbot-example-chips>

      <!-- Source picker and the clear-history button share one row. The button
           is only made visible once there's history to clear; because it sits
           beside the picker (not below it), hiding it leaves no gap and the
           picker never shifts. -->
      <div class="source-row">
        <app-source-selector
          [selectedSource]="(selectedSource$ | async) ?? Source.ALL"
          (sourceChange)="onSourceChange($event)">
        </app-source-selector>

        <button
          mat-flat-button
          class="clear-button"
          [class.clear-button--hidden]="(chatHistory ?? []).length <= 1"
          color="warn"
          [disabled]="
            (isLoading$ | async)! ||
            (chatbotService.requestInProgress$ | async)!
          "
          (click)="clearHistory()">
          {{ 'chat.clear' | translate }}
        </button>
      </div>

      <div class="query-field-container">
        <app-query-field
          [isShowFiltersButton]="false"
          [isShouldReset]="true"
          [isShowDataIncludedButton]="false"
          [isLoading]="
            (isLoading$ | async)! ||
            (chatbotService.requestInProgress$ | async)!
          "
          [example]="(exampleQuestion$ | async) ?? ''"
          [featureClass]="'chatbot-feature'"
          (sendQuery)="onSendMessage($event)">
        </app-query-field>
      </div>
    </div>
  </ng-container>
</div>
